// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__wkKG0","badge":"tabs_badge__BBFsd","badge-yellow":"tabs_badge-yellow__kDg4N","badge-green":"tabs_badge-green__xALv4","badge-red":"tabs_badge-red__3Mzck"};